import { Type } from '@angular/core';
import { GenericNotificationComponent } from './components/generic-notification/generic-notification.component';
import { NOTIFICATION_TYPE_COMPONENT_MAP } from './notification-type-component.map';
import { NotificationItemComponent } from './models/notification-item-component.model';
import { NotificationToastMessage } from './models/notification-type-registration.model';

const GENERIC_TOAST_MESSAGE: NotificationToastMessage = {
  titleKey: 'AgenticCX::Notification:Title',
  messageKey: 'AgenticCX::Notification:NewNotificationReceived',
};

/** Resolves the renderer for a `NotificationDto.type`, falling back to the generic renderer when unknown. */
export function resolveNotificationItemComponent(type: string): Type<NotificationItemComponent> {
  return NOTIFICATION_TYPE_COMPONENT_MAP[type]?.component ?? GenericNotificationComponent;
}

/**
 * Resolves the row-click navigation target for a `NotificationDto.type`+payload; `null` means "don't navigate".
 * `isGranted` checks the type's `requiredPolicy`, so a user who cannot open the target is not sent there.
 */
export function resolveNotificationTargetUrl(
  type: string,
  payload: string,
  isGranted: (policy: string) => boolean,
): string | null {
  const registration = NOTIFICATION_TYPE_COMPONENT_MAP[type];
  if (registration?.requiredPolicy && !isGranted(registration.requiredPolicy)) {
    return null;
  }

  return registration?.resolveTargetUrl?.(payload) ?? null;
}

/** Whether a live push of this `NotificationDto.type` should pop a toast. Defaults to `true` when unset. */
export function shouldShowToastForType(type: string): boolean {
  return NOTIFICATION_TYPE_COMPONENT_MAP[type]?.showToast ?? true;
}

/** Resolves the toast title/message for a live push, falling back to the generic copy when not customized. */
export function resolveNotificationToastMessage(type: string, payload: string): NotificationToastMessage {
  return NOTIFICATION_TYPE_COMPONENT_MAP[type]?.resolveToastMessage?.(payload) ?? GENERIC_TOAST_MESSAGE;
}
